const baseCN = {
  L001: "用户注册",
  L002: "手机",
  L003: "验证码",
  L004: "密码",
  L005: "我已经仔细阅读并接受《用户协议》",
  L006: "立即注册",
  L007: "返回登录",
  L008: "账号登录",
  L009: "动态登录",
  L010: "手机或邮箱",
  L011: "请向右滑动滑块填充拼图",
  L012: "立即登陆",
  L013: "忘记密码",
  L014: "账号注册",
  L015: "验证成功",
  L016: "验证失败",
  L017: "账号登录",
  L018: "账号注册",

  D001: "搜公司",
  D002: "全球企业背景信息",
  D003: "人脉信息查询",
  D004:
    "帮您快速了解企业信息，查找您的合作伙伴，了解您的竞争对手，达成最终交易",
  D005: "供应商、采购商",
  D006: "企业数据",
  D007: "产品库",
  D008: "征信报告",
  D009: "千万+",
  D010: "亿+",
  D011: "百万+",
  D012: "共找到约",
  D013: "个公司",
  D014: "国家/地区",
  D015: "员工数",
  D016: "营业额",
  D017: "行业",
  D018: "更多筛选",
  D019: "官网",
  D020: "社交",
  D021: "联系人",
  D022: "排除中国公司	",
  D023: "更多",
  D024: "搜索建议",
  D025: "最近浏览",
  D026: "公司列表",
  D027: "相关度",
  D028: "公司规模",
  D029: "按联系人数量",
  D030: "全选",
  D031: "公司信息",
  D032: "公司详情",
  D033: "产品服务标签",
  D034: "加入收藏",
  D035: "分享",
  D036: "公司概况",
  D037: "联系人",
  D038: "新闻动态",
  D039: "社交动态",
  D040: "抱歉，暂无动态信息",
  D041: "抱歉，暂无联系人信息",
  D042: "请输入产品服务关键词或公司名称",
  D043: "关键词",
  D044: "热搜指数",
  D045: "个联系人",
  D046: "联系人列表",
  D047: "联系人信息",
  D048: "联系人方式",
  D049: "所属公司",
  D050: "展开筛选",
  D051: "收起筛选",
  D052: "公司其他联系人",
  D053: "查看联系方式",
  D054: "收藏",
  D055: "已收藏",
  D056: "请输入人名进行搜索",
  D057: "我的收藏",
  D058: "我的联系人",
  D059: "我的公司",
  D060: "导出",
  D061: "会员服务",
  D062: "商圈邀请",
  D063: "退出登录",
  D064: "账户余额",
  D065: "账户类型",
  D066: "普通会员",
  D067: "充值",
  D068: "升级VIP",
  D069: "到期时间",
  D070: "账号设置",
  D071: "计费中心",
  D072: "企业认证",
  D073: "消息中心",
  D074: "账户信息",
  D075: "账号",
  D076: "绑定手机",
  D077: "绑定邮箱",
  D078: "已绑定",
  D079: "立即绑定",
  D080: "修改密码",
  D081: "个人信息",
  D082: "昵称",
  D083: "性别",
  D084: "男",
  D085: "女",
  D086: "真实姓名",
  D087: "公司",
  D088: "行业",
  D089: "职务",
  D090: "地址",
  D091: "名片",
  D092: "保存全部",
  D093: "会员额度内花费",
  D094: "次数",
  D095: "使用",
  D096: "剩余",
  D097: "单价",
  D098: "花费",
  D099: "记录",
  D100: "名称",
  D101: "类型",
  D102: "时间",
  D103: "总计",
  D104: "认证您的企业	",
  D105: "企业认证的益处",
  D106: "增加曝光",
  D107: "您的企业将在企业搜索库展示，全球B2B买家可以通过引擎搜到您的企。",
  D108: "提高额度",
  D109: "您的系统使用额度将提升，审核通过后，“联系人查看”额度将提高20次。",
  D110: "精准推荐",
  D111: "系统将依据您的企业情况，提供给您更符合的企业资讯数据。",
  D112: "公司名/公司邮箱",
  D113: "公司域名",
  D114: "所属行业",
  D115: "联系电话",
  D116: "您的职位",
  D117: "公司采购关键词",
  D118: "公司产品关键词",
  D119: "产品图片",
  D120: "名片",
  D121: "企业视频",
  D122: "立即认证",
  D123: "暂不认证",
  D124: "请输入",
  D125: "你有 ",
  DD125: " 条消息未读",
  D126: "消息标题",
  D127: "提交时间",
  D129: "暂无数据",
  D130: "特权对比",
  D131: "功能介绍",
  D132: "VIP会员",
  D133: "查询结果显示条数",
  D134: "数据导出",
  DD134: "(公司基本信息：地址、电话、经营范围、网站等)",
  D135: "高级筛选功能",
  DD135: "(国家区域、规模、营业额、行业等)",
  D136: "公司搜索次数",
  D137: "联系人搜索次数",
  D138: "公司详情",
  D139: "联系方式查",
  D140: "专属客服",
  D141: "立即购买",

  D142: "请输入常用手机或者邮箱",
  D143: "动态登录",
  D144: "请输入手机号码",
  D145: "获取验证码",
  D146: "请输入邮箱",
  D147: "邮箱",
  D148: "请输入验证码",
  D149: "收起",
  D150: "请输入国家/地区",
  D151: "请输入行业",
  D152: "是",
  D153: "否",
  D154: "有",
  D155: "社交媒体",
  D156: "标签",
  D157: "满足所有信用调查需求",
  D158:
    "Xieco提供全方位的信用报告，帮助您了解合作伙伴的详细背景、信用记录、最新经营情况、盈利能力、行业信息、现金流、偿还意愿和能力，为您全面衡量调查目标的信用风险。",
  D159: "专业分析师，有效识别风险",
  D160:
    "不同于其他平台的简单数据抓取，Xieco拥有10年行业经验的专业信用分析师团队，为您详细分析、全面核实。专业的人工判断，有效识别信用风险。",
  D161: "提交征信报告申请",
  D162: "征信报告表单提交",
  D163: "委托人信息",
  D164: "必填",
  D165: "公司名称",

  D166: "请输入企业完整名称",
  D167: "请输入完整的地址",
  D168: "请输入邮编",
  D169: "联系人",
  D170: "请输入联系人姓名",
  D171: "联系电话",
  D172: "传真",
  D173: "请输入传真号码，若无则用0代替",
  D174: "请输入电子邮箱地址",
  D175: "被调查企业/行业信息",
  D176: "企业/行业名称",
  D177: "请输入企业完整名称",
  D178: "企业地址",
  D179: "所在国家",
  D180: "请输入所在国家",
  D181: "所在省市",
  D182: "请输入所在省市",
  D183: "请输入联系电话",
  D184: "调查重点",
  D185: "请输入调查重点",
  D186: "产品速度",
  D187: "普通",
  D188: "加急",
  D189: "备注",
  D190: "请输入您的其他需求",
  D191: "提交",
  D192: "取消",

  D193: "请输入公司名称",
  D194: "请输入联系人姓名",
  D195: "请输入联系电话",
  D196: "请输入传真号码",
  D197: "请输入企业完整名称",
  D198: "请输入完整的地址",
  D199: "请输入所在国家",
  D200: "地图",
  D201: "加载中...",
  D202: "联系人详情",
  D203: "搜公司",
  D204: "搜联系人",
  D205: "我的收藏",
  D206: "暂无标签",
  D207: "导出邮箱",
  D208: "导出Excel",
  D209: "删除",
  D210: "立即搜索公司",
  D211: "加入VIP会员，享受更多特权",
  D212: "永久免费",
  D213: "续费",
  D214: " 页",
  D215: "会费项目",
  D216: "消费提醒",
  D217: "消费时间",
  D218: "敬请期待",
  D219: "额度外花费",
  D220: "元",
  D221: "企业认证",
  D228: "公司名称",
  D229: "公司邮箱",
  D230: "请输入邮箱",
  D231: "公司域名",
  D232: "请输入公司域名",
  D233: "请输入公司行业",
  D234: "所属行业",
  D235: "请输入行业",

  D236: "您的职位",
  D237: "请输入职位名称",
  D238: "公司采购关键词",
  D239: "请输入关键词并按下回车",
  D240: "公司产品关键词",

  D241: "产品图片",
  D242: "点此处上传产品图片",
  D243: "点此处修改传产品图片",

  D244: "名片",
  D245: "点此处上传名片",
  D246: "点此处修改名片",

  D247: "企业视频",
  D248: "点此处修改企业视频",
  D249: "点此处上传企业视频",

  D250: "立即认证",
  D251: "您已认证了以下企业",
  D252: "修改认证企业",
  D253: "账户设置",

  D254: "账号",
  D255: "您尚未绑定",
  D256: "立即绑定",
  D257: "修改密码",
  D258: "修改名片",

  D259: "邀请您的合作伙伴(上下游)",
  D260: "邀请上下游的益处",

  D261: "获取更多推荐",
  D262: "系统将根据您所邀请的上下游公司，为您推荐更多类似的企业。",

  D263: "邀请增加额度",
  D264:
    "您的系统使用额度将提升，每提交一个公司审核通过，“联系人查看”额度提高10次。",

  D265: "上下游样本公司提交",
  D266: "电话",
  D267: "请输入电话",

  D268: "已邀请的合作伙伴",
  D269: "您已提交了以下公司",
  D270: "审核状态",
  D271: "审核中",
  D272: "审核通过",
  D273: "审核失败",

  // D268: '已邀请的合作伙伴',
  // D269: '您已提交了以下公司',
  // D270: '审核状态',
  // D271: '审核中',
  // D272: '审核通过',
  // D273: '审核失败',

  D274: "分享或邀请您的同事或朋友",
  D275: "分享和邀请的益处",
  D276: "查看更多内容",
  D277: "能够查看您分享或邀请的企业所提交的企业名片咨询内容。",
  D278: "邮箱分享",

  D279: "请输入对方邮箱",
  D280: "立即邀请",
  D281: "新增一条",

  D282: "已邀请对象",
  D283: "您已成功邀请了以下用户",

  D284: "产品/行业关键词",
  D285: "公司名",
  D286: "未知",
  D287: "10M以下",
  D288: "500M以上",
  D289: "产品/行业关键词",
  D290: "公司名",
  D291: "秒前",
  D292: "分钟",
  D293: "分钟前",
  D294: "小时",
  D295: "小时前",
  D296: "天",
  D297: "天前",
  D298: "前",
  D299: "个星期",
  D300: "个月前",
  D301: "需要同意用户协议",
  D302: "您输入的手机号码有误",
  D303: "请输入您的手机号",
  D304: "密码长度需介于8～20个字符之间",
  D305: "该账号已被使用",
  D306: "游客您好",
  D307: "请注册/登录获取更多权益",
  D308: "加",
  D309: "次",
  D310: "查看公司详情",
  D311: "查看联系方式",
  D312: "请输入验证码",
  D313: "用户注册",
  D314: "用户",
  D315: "该账号已被使用",
  D316: "验证成功",
  D317: "验证失败",

  D318: '您输入的手机号码有误',
  D319: '验证码错误',
  D320: '绑定成功',
  D321: '绑定失败',
  D322: '该手机号码已被使用或您已经绑定过手机号码了',
  D323: '该邮箱已被使用或您已经绑定过邮箱了',
  D324: "系统繁忙，登录失败",
  D325: "绑定失败,验证码错误",
  D326: "验证码不能为空",
  D327: "系统繁忙，请稍后再试",
  D328: "验证码已发送成功",
  D329: "账户不存在",
  D330: "滑块验证失败",
  D331: "缺少必要参数type",
  D332: "注册验证码",
  D333: "邮箱绑定验证码",
  D334: "发送成功",
  D335: "您的公司搜索额度已耗尽",
  D336: "登录后取消翻页限制",
  D337: "登录后可使用收藏功能",
  D338: "删除成功",
  D339: "删除失败",
  D340: "是否确定删除该条收藏",
  D341: "注册失败！验证码错误！",
  D342: "用户名或密码不存在",
  D343: "注册类型不存在",
  D344: "当前账户已被占用",
  D345: "当前手机号码已被占用",
  D346: "上传名片只能是jpg/jpeg/bmp/png格式！",
  D347: "上传名片大小不能超过 2MB!",
  D348: "绑定",
  D349: "回到顶部",
  D350: "意见反馈",
  D351: "问题描述",
  D352: "请输入您的宝贵意见，我们将关注后续并通知您",
  D353: "衷心感谢您的支持，您的建议是我们改进的最大动力",
  D354: "立即搜索联系人",
  D355: "您的联系人搜索额度已耗尽",
  D356: "登录后可使用高级筛选器",
  D357: "登录后可查看联系人详情",
  D359: "登录后可查看",
  D360: "登录后可收藏",
  D361: "VIP会员才有导出权限",
  D362: "普通会员没有导出权限",
  D363: "抱歉，网页加载失败",
  D364: "查看联系方式",
  D365: "公司信息",
  D366: "普通会员只能浏览前十页",
  D367: "视频格式不支持",
  D368: "大小不得超过100M",
  D369: "衷心感谢您的认证，我们将在3-5个工作日进行审批，通过后将发送消息通知您",
  D370: "请输入1的倍数",
  D371: "花费项目",
  D372: "消费记录",
  D373: "提交成功",
  D374: "请打开微信客户端扫描",
  D375: "选择充值金额",
  D376: "选择支付方式",
  D377: "确认充值",
  D378: "其他金额$",
  D379: "￥399/月",
  D380: "￥239*12=2868/年",
  D381: "消息详情",
  D382: "数据由Xieco提供",
  D383: "游客没有导出权限",
  D384: "微信分享",
  D385: "请使用手机微信扫码分享",
  D386: "正在使用支付宝支付",
  D387: "正在使用PayPal支付",
  D388: "正在使用微信支付",
  D389: "已发送至绑定邮箱",
  D390: "未绑定邮箱，无法导出到email",
  D391: "一周内保持登录状态",
  D392: "全部",
  D393: "默认分组",
  D394: "编辑分组",
  D395: "可重命名删除分组",
  D396: "创建新分组",
  D397: "确认",
  D398: "请输入新分组名称",
  D399: "确认创建",
  D400: "返回",
  D401: "修改收藏内容所在分组",
  D402: "修改分组",
  D403: "请选择想要添加的分组",
  D404: "加入分组",
  D405: "提示",
  D406: "该分组下有数据，确定要删除分组名？",
  D407: "确认删除？",
  D408: "竞品",
  D409: "客户",
  D410: "供应商",
  D411: "经销商",
  D412: "按联系信息",
  D413: "福建省厦门市思明区前埔路软件园二期望海路55-B806",
  D414: "闽ICP备2020019984号-4",
  D415: "业务支持",
  D416: "设置",
  D417: "月",
  D418:	"共搜索到超过10000个公司，为您展示前一万条",
  D419:	"共搜索到超过10000个联系人，为您展示前一万个结果",
  D420:	"加入公司分组",
  D421:	"加入联系人分组",
  D422:	"导出功能对VIP用户开放，现在充值购买VIP套餐",
  D423: "10家公司/月",
  D424: "5位联系人/月",
  D425: "200家公司/月",
  D426: "2400家公司/年",
  D427: "20位联系人/月",
  D428: "240位联系人/年",
  D429: "¥4788/年",
  D430: '联系人无邮箱不计数',
  D431: '当月VIP会员特权数用完后，可充值余额继续使用',
  D432: '说明：',
  D433: '$58/月',
  D434: '$696/年',
  D435: '免费',
  D436: '月',
  D437: '年',
  D438: '$',
  D439: '请输入邀请码',
  D440:'邀请码激活',
  D441: '激活',
  D442: '亿+',
  D443: '个',
  D444: '百+',
  D445: '秒',
  D446: '企业数据',
  D447: '国家/地区',
  D448: '二级行业',
  D449: '获取报告',
  D450: '快速找到客户',
  D451: '由人工智能驱动的销售线索',
  D452: '微信',
  D453: '需付',
  D454: 'Xieco',
  D455: '服务全面升级',
  D456: '专为商务精英定制，精准快速联系目标关键人',
  D457: '了解更多',
  D458: '全球216个国家企业联系人数据',
  D459: '让精准数据驱动贸易',
  D460: 'Facebook',
  D461: '万里查简介',
  D462: '意见反馈',
  D463: '公司目录',
  D464: '隐私条款',
  D465: '关于我们',
  D466: '联系我们',
  D467: '微信公众号',
  D468: '友情链接',
  D469: '有效期',
  D470: '个月',
  D471: '个月',
  D472: '家',
  D473: '次',
  D474: '我的收藏',
  D475: '在线客服',
  D476: '个',
  D477: '人',
  D478: '请输入产品服务关键词或公司名称来搜索Facebook',
  D479: '',
  D480: '，',
  D481: 'Xieco全新2.2版本上线啦~',
  D482: '亲爱的小伙伴们，Xieco全新PC端2.2版本发布啦~',
  D483: '新版主要有如下内容：',
  D484: '1.首页改版，界面更友好;',
  D485: '2.增加D币功能，可以通过任务获取D币奖励，D币可以用于兑换查询额度等；',
  D486: '3.会员流量包内容更丰富，多种会员方案供选，更加丰富的使用场景。',
  D487: '还有更多细节上的优化，等着你来体验！',
  D488: '温馨提示：本次更新只涉及PC端，D币及流量包购买相关功能，请在PC端使用。',
  D489: '我知道啦',
  D490: '导出列表数据',
  D491: '注：此处导出的是公司列表页的数据，如需导出收藏公司的数据，请到我的收藏页操作',
  D492: '注：此处导出的是人脉列表页的数据，如需导出收藏人脉的数据，请到我的收藏页操作',
  D493: '导出收藏数据',
  D494: '导出列表数据',


  D512: "社交登录：",
  D513: "社交注册："
};
export default baseCN;



// WEBPACK FOOTER //
// ./src/lan/cn/cn_base.js